(function () {
  'use strict';

  function carryTracking(url) {
    if (!url || url.charAt(0) === '#') return url;
    try {
      var target = new URL(url, window.location.origin);
      var current = new URLSearchParams(window.location.search);
      current.forEach(function (value, key) {
        if (!target.searchParams.has(key)) target.searchParams.set(key, value);
      });
      return target.pathname + target.search + target.hash;
    } catch (_) { return url; }
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (href.indexOf('/pages/socket-wrench-tool') === 0) {
      anchor.setAttribute('href', carryTracking(href));
    }
  }, true);

  function toggleFaq(question, event) {
    var item = question.closest('.cursor-pointer') || question.parentElement;
    var scope = item && item.parentElement ? item.parentElement : item;
    var answer = scope && scope.querySelector('.answer-line');
    var icon = question.querySelector('.question-icon');
    if (!answer) return;
    if (event) event.preventDefault();
    var open = question.getAttribute('aria-expanded') !== 'true';
    answer.hidden = !open;
    answer.classList.toggle('show', open);
    question.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (icon) icon.style.transform = open ? 'rotate(0deg)' : 'rotate(-45deg)';
  }

  document.querySelectorAll('.question-line').forEach(function (question) {
    var item = question.closest('.cursor-pointer') || question.parentElement;
    var scope = item && item.parentElement ? item.parentElement : item;
    var answer = scope && scope.querySelector('.answer-line');
    if (answer) {
      answer.hidden = true;
      answer.classList.remove('show');
    }
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    question.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('click', function (event) {
    var question = event.target && event.target.closest ? event.target.closest('.question-line') : null;
    if (question) toggleFaq(question, event);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var question = event.target && event.target.closest ? event.target.closest('.question-line') : null;
    if (question) toggleFaq(question, event);
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('#pgAtc') : null;
    if (!button) return;
    var query = window.location.search;
    if (!query) return;
    setTimeout(function () {
      try {
        var selected = document.querySelector('.pg-card.pg-selected');
        if (!selected) return;
        // The canonical bundle script performs the actual navigation. This
        // listener only persists attribution for Shopify checkout recovery.
        sessionStorage.setItem('swt_tracking_query', query);
      } catch (_) {}
    }, 0);
  }, true);
})();
